// extracted by mini-css-extract-plugin
export default {"mui-paper":"Dialog-mui-paper","muiPaper":"Dialog-mui-paper","exit-button":"Dialog-exit-button","exitButton":"Dialog-exit-button"};